module.exports = __webpack_public_path__ + "img/logo_blue.bef8347.svg";